import { CancelToken } from "axios";
import { DeliveryApi } from "@/api/delivery.api";
import { FoodPickupPointPromise } from "@/types/food-pickup-point-promise.interface";

export class FoodPickupPointApi extends DeliveryApi {

  calculateDelivery(
      saleId: number,
      cancelToken?: CancelToken
  ): Promise<FoodPickupPointPromise> {
    return this.axios
        .post<{ promise: FoodPickupPointPromise }>(
            "/delivery/foodPickupPoint/promise",
            { saleId },
            { cancelToken }
        )
        .then((r) => r.data.promise);
  }
}
